/**
 * Image Hotspot Element
 * Image with clickable hotspots that reveal content
 */

import * as React from 'react';
import type { ElementDefinition } from '@ai-content-hub/content-kit';
import {
    imageHotspotElementSchema,
    type ImageHotspotElementData,
    type ImageHotspotItem,
} from './schema';
import { ImageHotspotEdit } from './ImageHotspotEdit';
import { ImageHotspotPlayer } from './ImageHotspotPlayer';

export {
    imageHotspotElementSchema,
    type ImageHotspotElementData,
    type ImageHotspotItem,
};

export {
    normalizeImageHotspotData,
    getBackgroundImageSrc,
    getBackgroundImageAlt,
    createDefaultHotspot,
} from './schema';

export { ImageHotspotEdit };
export { ImageHotspotPlayer };

export const imageHotspotElement: ElementDefinition<ImageHotspotElementData, never> = {
    schema: imageHotspotElementSchema,
    EditComponent: ImageHotspotEdit as React.ComponentType<any>,
    PlayerComponent: ImageHotspotPlayer as React.ComponentType<any>,
};
